import { render, staticRenderFns } from "./BoxCasamento.vue?vue&type=template&id=1f07af12&"
import script from "./BoxCasamento.vue?vue&type=script&lang=js&"
export * from "./BoxCasamento.vue?vue&type=script&lang=js&"
import style0 from "./BoxCasamento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports